import { render } from "./TopBar.vue?vue&type=template&id=f5f350b2&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=f5f350b2&lang=scss&scoped=true"
import "./TopBar.vue?vue&type=style&index=1&id=f5f350b2&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f350b2"]])

export default __exports__